import { locales } from '@americanexpress/conditional-features';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import MODULE_NAME from '../constants/moduleName';

const getSafeLocaleUtil = (unsafeLocale, dispatch) => {
  let responseLocale = locales.EN_US;

  try {
    if (!unsafeLocale) {
      return responseLocale;
    }

    const matchingLocale = Object.values(locales).find(
      (locale) => locale.toLowerCase() === unsafeLocale.toLowerCase()
    );

    if (matchingLocale) {
      responseLocale = matchingLocale;
    } else {
      dispatch(addErrorToReport(
        new Error(`Unsupported locale detected: ${unsafeLocale}`),
        {
          moduleID: MODULE_NAME,
          collectionMethod: 'getSafeLocaleUtil error',
        }
      ));
    }

    if (matchingLocale?.toLowerCase() === locales.ZH_HK.toLowerCase()) {
      responseLocale = locales.EN_HK;
    }
  } catch (error) {
    dispatch(addErrorToReport(
      error,
      {
        moduleID: MODULE_NAME,
        collectionMethod: 'getSafeLocaleUtil error',
      }
    ));
  }

  return responseLocale;
};

export default getSafeLocaleUtil;
